/* Bedtextielonline (Claude): actiekaart '2e dekbedovertrek aan halve prijs' in de kop van de dekbedovertrekken.
   Staat als glazen kaart in de donkere kop van de collectie (naast de titel; op de gsm eronder) en kijkt naar je winkelwagen:
   - nog niets: twee lege vakjes en de actie in één zin
   - er wacht 1 dekbedovertrek: dat staat in het eerste vakje, het tweede vakje wacht op je keuze (-50%)
   - al per 2: beide vakjes gevuld, groen: de korting staat in je winkelwagen
   Wordt geladen via snippets/btol-actie-2e.liquid (plek 'kop'), dus alleen als de actie aan staat. */
(function () {
  if (window.__btolA2k) return;
  window.__btolA2k = true;
  var tagCache = {};

  /* opmaak als glazen kaart in de donkere kop: hoort bij de foto i.p.v. erop geplakt te lijken (op de computer rechts naast titel en tekst) */
  var st = document.createElement('style');
  var k = '.btol-wiz__kop--actie .btol-a2k';
  st.textContent =
    k + '{box-sizing:border-box;min-width:0;max-width:100%;grid-template-columns:auto minmax(0,1fr)!important;row-gap:10px!important;column-gap:14px!important;padding:18px 20px!important;border-radius:20px!important;' +
      'background:rgba(255,255,255,.12)!important;-webkit-backdrop-filter:blur(18px) saturate(1.3);backdrop-filter:blur(18px) saturate(1.3);' +
      'border:1px solid rgba(255,255,255,.24)!important;box-shadow:0 12px 40px rgba(10,8,25,.25)!important;color:#fff!important;text-align:left}' +
    k + ' .btol-a2b__duo{grid-row:auto!important;padding-top:6px}' +
    k + ' .btol-a2b__titel{align-self:center!important;font-size:17px!important;line-height:1.25!important;color:#fff!important}' +
    k + ' .btol-a2b__titel span{color:#FFB199!important}' +
    k + '.is-binnen .btol-a2b__titel span{color:#9BE3B4!important}' +
    k + ' .btol-a2b__uitleg{grid-column:1 / -1!important;font-size:14px!important;line-height:1.45!important}' +
    k + ' .btol-a2b__uitleg,' + k + ' .btol-a2b__uitleg strong{color:rgba(255,255,255,.88)!important}' +
    k + ' .btol-a2b__plus{color:#fff!important}' +
    k + ' .btol-a2b__vak:not(.is-vol){background:rgba(255,255,255,.14)!important;border:1.5px dashed rgba(255,255,255,.5)!important;box-shadow:none!important}' +
    k + ' .btol-a2b__vak:not(.is-vol) i{color:#fff!important}' +
    /* computer: kaart rechtsboven in de kop; ze mag naast de stappen (Maat, Materiaal) zakken, zodat er geen lege band onder de tekst komt.
       De kop zelf blijft 'static' (anders krimpt de foto-achtergrond van het paneel mee); de plaats zet ruimte() hieronder. */
    '@media (min-width:1000px){.btol-wiz__kop--actie{padding-right:420px}' +
      '.btol-wiz__kop--actie > .btol-a2k{position:absolute!important;width:380px;margin:0!important;z-index:1}}' +
    '@media (max-width:999px){.btol-wiz__kop--actie > .btol-a2k{margin:14px 0 4px!important;padding:14px 16px!important}' + k + ' .btol-a2b__titel{font-size:16px!important}}';
  document.head.appendChild(st);

  function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }
  function beeld(src) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120' : ''; }

  function haalMand() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = (cart.items || []).filter(function (i) { return i.product_type === 'Dekbedovertrek'; });
      return Promise.all(items.map(function (i) {
        if (!tagCache[i.handle]) {
          tagCache[i.handle] = fetch('/products/' + i.handle + '.js').then(function (r) { return r.json(); }).then(function (p) { return p.tags || []; }).catch(function () { return []; });
        }
        return tagCache[i.handle];
      })).then(function (tags) {
        var lijst = [];
        items.forEach(function (i, k) {
          var t = (tags[k] || []).map(function (x) { return String(x).toLowerCase(); });
          if (t.indexOf('uni') > -1 || t.indexOf('uitverkoop') > -1) return;
          for (var q = 0; q < i.quantity; q++) lijst.push({ titel: i.product_title, beeld: i.image });
        });
        return lijst;
      });
    });
  }

  function vak(item, sticker) {
    return '<span class="btol-a2b__vak' + (item ? ' is-vol' : '') + '">' +
      (item ? '<img src="' + esc(beeld(item.beeld)) + '" alt="" loading="lazy">' : '<i>?</i>') +
      (sticker ? '<b class="btol-a2b__sticker">-50%</b>' : '') + '</span>';
  }

  function teken(lijst) {
    var plek = document.querySelector('[data-btol-a2-kop]');
    if (!plek) return;
    /* in de kop van de collectie (naast de titel, op de gsm eronder); zonder kop: boven de lijst */
    var kop = document.querySelector('.btol-wiz__panel .btol-wiz__kop') || document.querySelector('.btol-wiz__kop');
    if (kop) {
      if (plek.parentNode !== kop) kop.appendChild(plek);
      kop.classList.add('btol-wiz__kop--actie');
    } else {
      var doel = document.querySelector('.v-stack:has(> .collection-toolbar)') || (document.querySelector('.collection-toolbar') || {}).parentNode;
      if (doel && plek.parentNode !== doel) doel.insertBefore(plek, doel.firstChild);
    }
    var n = lijst.length, html = '', binnen = false;
    if (n % 2 === 1) {
      var w = lijst[n - 1];
      html = '<div class="btol-a2b__duo" aria-hidden="true">' + vak(w) + '<span class="btol-a2b__plus">+</span>' + vak(null, true) + '</div>' +
        '<p class="btol-a2b__titel">Kies je 2e aan <span>halve prijs</span></p>' +
        '<p class="btol-a2b__uitleg"><strong>' + esc(w.titel) + '</strong> ligt al in je winkelwagen. Het goedkoopste van de twee krijg je aan de helft.</p>';
    } else if (n > 0) {
      binnen = true;
      html = '<div class="btol-a2b__duo" aria-hidden="true">' + vak(lijst[n - 2]) + '<span class="btol-a2b__plus">+</span>' + vak(lijst[n - 1], true) + '</div>' +
        '<p class="btol-a2b__titel">Je 2e dekbedovertrek is aan <span>halve prijs</span></p>' +
        '<p class="btol-a2b__uitleg">De korting staat al in je winkelwagen. Neem er nog 2 en het goedkoopste krijg je weer aan de helft.</p>';
    } else {
      html = '<div class="btol-a2b__duo" aria-hidden="true">' + vak(null) + '<span class="btol-a2b__plus">+</span>' + vak(null, true) + '</div>' +
        '<p class="btol-a2b__titel">2e dekbedovertrek aan <span>halve prijs</span></p>' +
        '<p class="btol-a2b__uitleg">Kies er 2 en het goedkoopste krijg je aan de helft. Mix gerust: ander dessin, maat of merk.</p>';
    }
    plek.className = 'btol-a2b btol-a2k' + (binnen ? ' is-binnen' : '');
    plek.innerHTML = html;
    plek.hidden = false;
    ruimte();
  }

  /* de kop moet minstens zo hoog zijn dat de kaart niet over de maat-tegels valt (de stappen ernaast mogen wel) */
  function ruimte() {
    var kop = document.querySelector('.btol-wiz__kop--actie');
    var kaart = kop && kop.querySelector('.btol-a2k');
    if (!kaart) return;
    if (!window.matchMedia('(min-width:1000px)').matches) { kop.style.minHeight = ''; kaart.style.top = kaart.style.right = ''; return; }
    var par = kaart.offsetParent;
    if (par) {
      kaart.style.top = kop.offsetTop + 'px';
      kaart.style.right = Math.max(0, par.clientWidth - (kop.offsetLeft + kop.offsetWidth)) + 'px';
    }
    var stappen = kop.parentNode && kop.parentNode.querySelector('.btol-wiz__steps');
    var naast = stappen ? stappen.offsetHeight + 14 : 0;
    kop.style.minHeight = Math.max(0, kaart.offsetHeight - naast) + 'px';
  }
  window.addEventListener('resize', ruimte);
  window.addEventListener('load', ruimte);

  function vernieuw() { haalMand().then(teken).catch(function () { teken([]); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vernieuw); else vernieuw();
  ['cart:change', 'cart:refresh', 'cart:update'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(vernieuw, 150); }); });
})();